var $6b7d29a94eebcc3f$exports = {};
$6b7d29a94eebcc3f$exports = {
    "colorSwatchPicker": `Farvepr\xf8ver`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe6lg et element`,
    "tableResizer": `St\xf8rrelses\xe6ndring`
};


export {$6b7d29a94eebcc3f$exports as default};
//# sourceMappingURL=da-DK.mjs.map
